import { render, staticRenderFns } from "./Layout.vue?vue&type=template&id=6107bbe2&scoped=true"
import script from "./Layout.vue?vue&type=script&lang=ts"
export * from "./Layout.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6107bbe2",
  null
  
)

export default component.exports